<template>
  <v-container class="pa-0 grid-principal" fluid>
    <div class="grid-principal__barra">
      <div class="grid-principal__busca">
        <v-btn
          v-if="filtroAtivado"
          color="primary"
          round
          class="ml-0"
          @click="dialogFiltro = true "
        >
          FILTRO
        </v-btn>
        <v-btn
          v-else
          color="primary"
          round
          flat
          outline
          class="ml-0"
          @click="dialogFiltro = true "
        >
          FILTRO
        </v-btn>
        <v-text-field
          v-model="filtro.pesquisa.conteudo"
          prepend-icon="search"
          @click:prepend="buscarApoliceQuery()"
          label="Buscar"
          hint="Informe o CNPJ ou Razão Social do cliente"
          clearable
          class="grid-principal__campo-busca"
          v-on:keyup.enter="buscarApoliceQuery()"
        ></v-text-field>
      </div>
      <div class="grid-principal__acoes">
        <v-select
          :items="listaVersionamentoEssor"
          v-model="versionamentoEssorDefault"
          item-text="versao"
          hide-details
          class="versionamento"
        >
          <template slot="selection" slot-scope="data">
            N° {{ data.item.titulo }} {{ formatarNumeroCotacao(data.item.versao) }}
          </template>
          <template slot="item" slot-scope="data">
            {{ data.item.titulo }} {{ formatarNumeroCotacao(data.item.versao) }} ({{ formatarData(data.item.inicioVigencia) }} - {{ data.item.fimVigencia === "Vigente" ? data.item.fimVigencia : formatarData(data.item.fimVigencia) }})
          </template>
        </v-select>
        <v-btn @click="abrirDialogCopiarCotacao" color="primary" :disabled="selected === null" round>
          Copiar Proposta
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!podeEndossar"
          @click="abrirdialog"
          round
        >
          Novo Endosso
        </v-btn>
        <v-btn color="primary" @click="btnRenovacao" :disabled="!desabilitaRenovacao" round>
          Renovar Apólice
        </v-btn>
        <v-btn color="secondary" class="mr-0" @click="dialogFile = true" round>
          Nova Cotação
        </v-btn>
      </div>
    </div>

    <div class="special-container grid-principal__tabela">
      <template style="margin: 0 20px;">
        <div>
          <v-data-table
            :headers="headers"
            :items="apoliceList"
            :rows-per-page-items="[10, 25, 50, 100]"
            rows-per-page-text="Linhas por página"
            :total-items="paginacao.totalItems"
            :pagination.sync="paginacao"
            must-sort
            hide-actions
            item-key="item"
            class="elevation-1 table-grid text-align-center"
          >
            <template v-slot:no-data>
              <p class="no-data-apolice" >Nenhum resultado encontrado.</p>
            </template>
            <template v-slot:items="props" >
              <td class="themeGrey--text click">
                <v-checkbox
                  class="pl-3"
                  color="primary"
                  primary
                  hide-details
                  :value="props.item.id === selected"
                  @change="value => (selected = value ? props.item.id : null, dataFimSelected = value ? props.item.dateFim : null)"
                  :disabled="selected !== null && selected !== props.item.id"
                >
                </v-checkbox>
              </td>
              <td class="text-xs-center">
                <IconeChatTratativa
                  v-if="temTratativa(props.item.id)"
                  :qtdNaoLidas="qtdNaoLidasDaLinha(props.item.id)"
                  :notificacaoInformativa="notificacaoInformativaDaLinha(props.item.id)"
                  :titulo="tituloDoChat(props.item.idPropostaStatus)"
                  @abrir="abrirDialogTratativa(props.item.id)"
                />
              </td>
              <td class="themeGrey--text coluna-status-tratativa">
                <span class="coluna-status-tratativa__conteudo">
                  <BolinhaStatusTratativa :cor="corDaBolinha(props.item)" />
                  <span class="click" @click="abrirApolice(props.item.id)">
                    {{ traduzirStatus(props.item.idPropostaStatus) }}
                  </span>
                </span>
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ formatNomeTecnicoResponsavel(props.item.nomeTecnicoResponsavel) }}
                    </span>
                  </template>
                  <span v-if="props.item.nomeTecnicoResponsavel != null" style="margin-top: 80px">{{ props.item.nomeTecnicoResponsavel }}</span>
                </v-tooltip>
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ props.item.numeroReserva }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ formatarNumeroCotacao(props.item.apoliceNumeroCotacao) }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ props.item.proponenteRazaoSocial.length > 18 ? props.item.proponenteRazaoSocial.substring(0, 19).concat("...") : props.item.proponenteRazaoSocial }}
                    </span>
                  </template>
                  <span style="margin-top: 50px">{{ props.item.proponenteRazaoSocial }}</span>
                </v-tooltip>
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ formatarCnpj(props.item.proponenteCnpj) }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ props.item.quantidadeItens }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ formatMoney(props.item.totalPremio) }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ props.item.apoliceNumeroProposta }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ props.item.apoliceNumero }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ formatarData(props.item.dateInicio) }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ formatarData(props.item.dateFim) }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ formatarData(props.item.dataPrimeiraParcela) }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                {{ props.item.quantidadeEndossos }}
              </td>
              <td @click="abrirApolice(props.item.id)" class="themeGrey--text click">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ formatNomeTecnicoResponsavel(props.item.nomeUsuarioCorretor) }}
                    </span>
                  </template>
                  <span v-if="props.item.nomeUsuarioCorretor != null" style="margin-top: 80px">{{ props.item.nomeUsuarioCorretor }}</span>
                </v-tooltip>
              </td>
              <td>
                <a
                  class="btn-dialog-historico"
                  @click="
                    abrirdialogHistorico(
                      props.item.id,
                      props.item.apoliceNumeroProposta,
                      props.item.idPropostaStatus
                    )
                  "
                >
                  Ver histórico
                </a>
              </td>
            </template>
          </v-data-table>
          <div class="datatable-footer-custom">
            <div class="datatable-footer-custom__perpage">
              <span class="datatable-footer-custom__label">Linhas por página:</span>
              <v-select
                :items="[10, 25, 50, 100]"
                v-model="paginacao.rowsPerPage"
                hide-details
                class="datatable-footer-custom__select"
              ></v-select>
            </div>
            <span class="datatable-footer-custom__range">{{ intervaloPaginaTexto }}</span>
            <v-btn
              icon
              flat
              :disabled="paginacao.page <= 1"
              @click="paginacao.page = 1"
            >
              <v-icon :color="paginacao.page <= 1 ? 'themeGrey' : 'primary'">first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              :disabled="paginacao.page <= 1"
              @click="paginacao.page--"
            >
              <v-icon :color="paginacao.page <= 1 ? 'themeGrey' : 'primary'">chevron_left</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              :disabled="paginacao.page >= totalPaginas"
              @click="paginacao.page++"
            >
              <v-icon :color="paginacao.page >= totalPaginas ? 'themeGrey' : 'primary'">chevron_right</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              :disabled="paginacao.page >= totalPaginas"
              @click="paginacao.page = totalPaginas"
            >
              <v-icon :color="paginacao.page >= totalPaginas ? 'themeGrey' : 'primary'">last_page</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
    </div>
    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialogFile"
          @update:returnValue="fecharDialogArquivo"
          max-width="800px"
        >
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline"> IMPORTAR PLANILHA</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12 sm6 md3>
                    <a flat @click="salvarPlanilhaModelo">
                      Baixar Modelo de Excel
                    </a>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <label
                      for="file-upload"
                      :class="['button-custom', { disabled: loading }]"
                    >
                      ARQUIVO
                    </label>
                    <input
                      @change="processarArquivo($event)"
                      id="file-upload"
                      type="file"
                      :disabled="loading"
                      v-if="dialogFile"
                    />
                  </v-flex>
                  <v-flex xs12 md7 class="pl-4">
                    <input
                      type="text"
                      class="name-arquivo"
                      v-model="arquivo.name"
                    />
                    <v-progress-circular
                      v-if="loading"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions class="px-5 pb-5">
              <div v-if="!arquivoValido">
                <p class="text-error">{{
                  erro === undefined || null
                    ? "Não foi possível importar o documento."
                    : erro
                }}</p>
                <br />
                <small class="text-error">
                  {{
                    arquivoFaltante.length
                      ? `${
                          arquivoFaltante.length === 1
                            ? "A coluna"
                            : "As colunas"
                        } "${arquivoFaltante.join('", "')}" ${
                          arquivoFaltante.length === 1
                            ? "não foi encontrada"
                            : "não foram encontradas"
                        }`
                      : "Arquivo inválido"
                  }}
                </small>
              </div>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="fecharDialogArquivo"
                >CANCELAR
              </v-btn>
              <v-btn
                :disabled="loading"
                class="button-custom"
                flat
                @click="submeterArquivo(false)"
                v-if="!mostrarBotaoImportarComErros"
                >IMPORTAR</v-btn>
              <v-btn
                :disabled="loading"
                class="button-custom error"
                flat
                color="error"
                @click="submeterArquivo(true)"
                v-else
                style="color: white!important;"
                >IMPORTAR COM ERROS</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogCopiarCotacao" max-width="560px">
          <ModalCopiarCotacao
            v-if="dialogCopiarCotacao"
            @confirmar="confirmarCopiaCotacao"
            @cancelar="dialogCopiarCotacao = false"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <template>
        <v-layout row justify-center>
          <v-dialog persistent v-model="dialog" max-width="600px">
            <ModalEndossos
              v-if="dialog"
              :dialog="dialog"
              :idApolice="selected"
              :tipoEndossoList="tipoEndossoList"
              :idPropostaStatus="selectedPropostaStatus != null ? String(selectedPropostaStatus) : null"
              @fecharDialogoEndosso="dialog = false"
              @abrirEndossoCancelamento="
                (dialog = false), (dialogEndossoCancelamento = true)
              "
            />
          </v-dialog>
        </v-layout>
      </template>

      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogProgress" max-width="800px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">AVALIANDO ITENS</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12>
                    <span>
                      Por favor, aguarde o processamento. Isso pode levar alguns
                      minutos
                    </span>
                  </v-flex>
                  <v-flex align-center d-flex xs12>
                    <v-progress-linear
                      heigth="2px"
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogProgress = false"
                >CANCELAR
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <v-snackbar
      :timeout="3000"
      :color="snackbar.sucesso ? 'success' : 'error'"
      multi-line
      v-model="snackbar.visivel"
    >
      {{ snackbar.mensagem }}
      <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
    </v-snackbar>
    <template>
      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="dialogEndossoCancelamento"
          max-width="900px"
        >
          <ModalEndossoCancelamento
            v-if="dialogEndossoCancelamento"
            :dialog="dialogEndossoCancelamento"
            @fecharDialogEndossoCancelamento="dialogEndossoCancelamento = false"
            :somenteLeitura="camposDisabled"
            :idApolice="selected"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogHistorico" max-width="600px">
          <ModalHistorico
            v-if="dialogHistorico"
            :dialog="dialogHistorico"
            @fecharDialogHistorico="dialogHistorico = false"
            :numeroProposta="this.numeroPropostaHistorico"
            :idStatus="this.statusPropostaHistorico"
            :idApolice="this.idApoliceClick"
            :cotacao="true"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogTratativa" max-width="1000px">
          <ModalTratativaAnalista
            v-if="dialogTratativa"
            :idApolice="idApoliceTratativa"
            :dadosSolicitacao="dadosSolicitacaoTratativa"
            @fechar="fecharDialogTratativa"
            @atualizada="buscarResumoTratativas"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogErros" max-width="520px">
          <ModalHistoricoErro
            v-if="dialogErros"
            :dialog="dialogErros"
            @fecharDialogHistoricoErro="dialogErros = false"
            :idApolice="numeroPropostaHistoricoErro"
            :cotacao="true"
            scrollable
          />
        </v-dialog>
      </v-layout>
    </template>
   ' <template>
      <v-dialog v-model="dialogFiltro" persistent width="300">
        <ModalFiltro
          :propostaStatusList = " propostaStatusList "
          :propostaTecnicoResponsavelList = " propostaTecnicoResponsavelList "
          :endossoStatusList = " endossoStatusList "
          :inicioVigenciaList = "inicioVigenciaList"
          :filtroAtivado = " filtroAtivado "
          :coberturasLista = " listaCoberturasFiltro "
          :segurosLista = "listaSegurosFiltro"
          :categoriaVeiculoLista = " listaCategoriaVeiculo "
          @formFiltroLimpo = "dadosFiltroLimpados "
          @fecharModalFiltro = "dialogFiltro = false "
          @filtrarDadosModal = "tratamentoRequestFiltrarDados"
          @ativaFiltro="filtroAtivado = true"
          :dadosFiltroAtivado = "modelFiltro"
          :ufsLista = " listaUfEndereco "
        >
        </ModalFiltro>
      </v-dialog>
    </template>'
    <template>
      <v-dialog

      persistent

      v-model="loaderFiltro"
      width="auto"

      content-class="elevation-0"
      >
        <v-card class="loader-overlay">

          <v-progress-circular indeterminate color="primary" :size="93" :width="5"></v-progress-circular>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import CustomFormat from "@/helpers/custom-format";

import usuarioHelper from "@/helpers/usuario-logado.js";
import { saveAs } from "file-saver";
import { adicionarId } from "@/helpers/url-helper.js";
import ModalEndossos from "./ModalEndosso.vue";
import ModalEndossoCancelamento from "./ModalEndossoCancelamento.vue";
import ModalHistorico from "./ModalHistorico.vue";
import ModalHistoricoErro from "./ModalHistoricoErro.vue";
import propostaStatusEnum from "@/helpers/tipo-proposta-cotacao.js";
import diasFaltandoEnum from "@/helpers/dias-faltando-liberar-renovacao-enum.js";
import ModalFiltro from "./ModalFiltro.vue";
import ModalCopiarCotacao from "./ModalCopiarCotacao.vue";
import planilhaItens from "@/helpers/planilha-itens.js";
import StarRating from "vue-star-rating";
import IconeChatTratativa from "@/components/shared/IconeChatTratativa.vue";
import ModalTratativaAnalista from "@/components/pages/tratativa/ModalTratativaAnalista.vue";
import BolinhaStatusTratativa from "@/components/shared/BolinhaStatusTratativa.vue";
import statusTratativa from "@/helpers/status-tratativa.js";

const INTERVALO_RESUMO_TRATATIVAS = 60000;

export default {
  name: "GridPrincipal",
  components: {
    ModalEndossos,
    ModalEndossoCancelamento,
    ModalHistorico,
    ModalHistoricoErro,
    ModalFiltro,
    ModalCopiarCotacao,
    StarRating,
    IconeChatTratativa,
    ModalTratativaAnalista,
    BolinhaStatusTratativa
  },
  data() {
    return {
      listaUfEndereco: [],
      loaderFiltro: false,
      filtroAtivado: false,
      dialogFiltro: false,
      dataFimSelected: null,
      btnClassificacaoAlta: false,
      btnClassificacaoMedia: false,
      btnClassificacaoBaixa: false,
      nmrClassificacaoBaixa: 0,
      nmrClassificacaoMedia: 0,
      nmrClassificacaoAlta: 0,
      dialog: false,
      dialogEndossoCancelamento: false,
      apolice: {},
      idTipoEndosso: null,
      tipoEndossoList: [],
      idRiscoGerenciamento: null,
      numeroReserva: null,
      valueDeterminate: 50,
      dialogFile: false,
      dialogEndosso: false,
      dialogProgress: false,
      dialogHistorico: false,
      loading: false,
      selected: null,
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        },
        status: {
          opened: false,
          opcoes: [{id: 0, titulo: "Todos"}],
          selecionado: null
        }
      },
      paginacao: {
        page: parseInt(sessionStorage.getItem("pageGridPrincipal")) || 1,
        rowsPerPage: parseInt(sessionStorage.getItem("rowsPerPageGridPrincipal")) || 10,
        totalItems: 0,
        sortBy: null,
        descending: false
      },
      headers: [
        { text: "", align: "center", value: "", sortable: false , width:"80px"},
        { text: "CHAT", align: "center", value: "chat", sortable: false, width:"60px" },
        { text: "STATUS", align: "left", value: "status", sortable: true, width:"80px" },
        { text: "TÉCNICO RESPONSÁVEL DA APÓLICE", align: "center", value: "nomeTecnicoResponsavel", sortable: false, width:"120px" },
        { text: "N. Reserva", align: "center", value: "numeroReserva", sortable: false, width:"40px" },
        { text: "CÓD. COTACÃO", align: "center", value: "apoliceNumeroCotacao", sortable: false, width:"40px" },
        { text: "RAZÃO SOCIAL", align: "center", value: "razaoSocial", sortable: true, width:"180px" },
        { text: "CNPJ", align: "center", value: "cnpj", sortable: true, width:"200px" },
        { text: "QTD. ITENS", align: "center", value: "qtdItens", sortable: true, width:"80px" },
        { text: "PRÊMIO TOTAL (R$)", align: "center", value: "premioTotal", sortable: true, width:"100px" },
        { text: "PROPOSTA", align: "center", value: "apoliceNumeroProposta", sortable: false, width:"20px" },
        { text: "APÓLICE", align: "center", value: "apoliceNumero", sortable: false, width:"80px" },
        { text: "INICIO VIGÊNCIA", align: "center", value: "inicioVigencia", sortable: true, width:"80px" },
        { text: "FIM VIGÊNCIA", align: "center", value: "fimVigencia", sortable: true, width:"80px" },
        { text: "DATA 1° PARCELA", align: "center", value: "dataPrimeiraParcela", sortable: false, width:"80px" },
        { text: "ENDOSSOS", align: "center", value: "endossos", sortable: false, width:"90px" },
        { text: "CORRETOR PARCEIRO", align: "center", value: "nomeUsuarioCorretor", sortable: false, width:"160px" },
        { text: "HISTÓRICO DE STATUS", align: "center", value: "historico", sortable: false, width:"110px" }
      ],

      apoliceList: [],
      propostaStatusList: [],
      propostaTecnicoResponsavelList: [],
      endossoStatusList: [],
      inicioVigenciaList: [],
      listaCoberturasFiltro: [],
      listaSegurosFiltro: [],
      listaCategoriaVeiculo: [],
      listaVersionamentoEssor: [],
      versionamentoEssorDefault: {},
      arquivo: {},
      arquivoValido: true,
      arquivoFaltante: [],
      conteudoPlanilha: null,
      numeroPropostaHistoricoErro: null,
      erroPlanilha: null,
      dialogErros: false,
      numeroPropostaHistorico: null,
      idStatusHistorico: null,
      erro: null,
      idApoliceClick: null,
      copiaProposta: null,
      dialogCopiarCotacao: false,
      dialogTratativa: false,
      idApoliceTratativa: null,
      dadosSolicitacaoTratativa: null,
      resumoTratativas: {},
      intervaloResumoTratativas: null,
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ""
      },
      modelFiltro: {},
      ignorarErrosImportacao: false,
      mostrarBotaoImportarComErros: false,
      mensagemChassiConstaApoliceVigente: 'O(s) chassi(s) já constam em uma apólice vigente:',
      mensagemChassiPossuiReservaMercado: 'O(s) chassi(s) já possuem uma reserva de mercado:',
    };
  },
  computed: {
    dataAtualComputada() {

        const dataAtual = new Date();
        var d = new Date(dataAtual),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    },
    idPerfilUsuarioLogado() {
      const usuario = usuarioHelper.USUARIO_LOGADO();
      return usuario && usuario.perfil ? usuario.perfil.id : null;
    },
    selectedPropostaStatus() {
      if (!this.selected) return null;
      const apolice = this.apoliceList.find(a => a.id == this.selected);
      return apolice ? apolice.idPropostaStatus : null;
    },
    podeEndossar() {
      if (!this.selected) return false;
      const apolice = this.apoliceList.find(a => a.id == this.selected);
      return !!apolice
          && apolice.idPropostaStatus === propostaStatusEnum.statusProposta.APROVADA
          && !!apolice.apoliceNumero;
    },
    desabilitaRenovacao() {
      let validaLiberarRenovDias = false;
      let dataFimSelectFormat = new Date(this.dataFimSelected);
      let dataAtualFormat = new Date(this.dataAtualComputada);
      var diasDiferenca = dataFimSelectFormat.getTime() - dataAtualFormat.getTime();
      let statusCotacao = null;
      for(var apolice of this.apoliceList) {
        if(apolice.id == parseInt(this.selected) ) {
          statusCotacao = apolice.idPropostaStatus
        }
      }
      let diasFaltandoAux = Math.ceil(diasDiferenca / (1000 * 3600 * 24));
      if(diasFaltandoAux <= diasFaltandoEnum.diasFaltando.RENOVACAO && statusCotacao == propostaStatusEnum.statusProposta.APROVADA) {
        validaLiberarRenovDias = true
      }

      return this.dataFimSelected && this.selected && validaLiberarRenovDias;
    },
    filtroComputed: function() {
      const self = this;
      return {
        filtroStatusString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado;
          } else {
            return "Status";
          }
        },
        statusSelecionadoDescricaoString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado;
          } else {
            return "";
          }
        }
      };
    },
    customFormatComputed: function() {
      return CustomFormat;
    },
    ordenacaoKey() {
      return `${this.paginacao.sortBy}|${this.paginacao.descending}`;
    },
    totalPaginas: function() {
      return Math.max(
        1,
        Math.ceil(this.paginacao.totalItems / this.paginacao.rowsPerPage)
      );
    },
    intervaloPaginaTexto: function() {
      const total = this.paginacao.totalItems;
      if (total === 0) {
        return "0 de 0";
      }
      const inicio = (this.paginacao.page - 1) * this.paginacao.rowsPerPage + 1;
      const fim = Math.min(
        this.paginacao.page * this.paginacao.rowsPerPage,
        total
      );
      return `${inicio}-${fim} de ${total}`;
    }
  },
  watch: {
    "paginacao.page"(val) {
      sessionStorage.setItem("pageGridPrincipal", val);
      this.recarregarLista();
    },
    "paginacao.rowsPerPage"(val) {
      sessionStorage.setItem("rowsPerPageGridPrincipal", val);
      this.recarregarLista();
    },
    filtroAtivado(val) {
      if(!val) {
        this.buscarApolices()
      }
    },
    apoliceList() {
      this.buscarResumoTratativas();
    },
    ordenacaoKey() {
      if (this.paginacao.page === 1) {
        this.recarregarLista();
      } else {
        this.paginacao.page = 1;
      }
    },
  },
  mounted() {
    this.idApolice = this.$route.query.id;
    this.$store.commit("formCotacao/limparTudo");
    if(sessionStorage.getItem('idClassificacaoBotaoPrioridadeCotacao') != null ) {
      const idClassificacaoBotaoPrioridadeCotacao = sessionStorage.getItem('idClassificacaoBotaoPrioridadeCotacao');
      this.tratamentoBotaoClassificacao(idClassificacaoBotaoPrioridadeCotacao);
    } else if (!this.filtroAtivado) {
      this.buscarApolices();
    }

    this.buscarStatus();
    this.buscarVersionamentoEssor();
    this.buscarInicioVigencia();
    this.buscarCoberturasFiltro();
    this.buscarSegurosFiltro();
    this.buscaEnderecosUf();
    this.buscarCategoriasVeiculo();
    this.buscarTecnicosResponsaveis();
    this.buscarStatusEndossos();
    if (sessionStorage.getItem("pageGridPrincipal") == null) {
      this.paginacao.page = 1;
    }

    this.iniciarPollingTratativas();
  },

  beforeDestroy() {
    this.pararPollingTratativas();
  },

  methods: {
    corDaBolinha(item) {
      if (!this.temTratativa(item.id)) return "";
      return this.corStatusTratativa(item.idPropostaStatus);
    },
    corStatusTratativa(idPropostaStatus) {
      return statusTratativa.corStatus(
        Number(idPropostaStatus),
        Number(this.idPerfilUsuarioLogado)
      );
    },
    tituloDoChat(idPropostaStatus) {
      const rotulo = statusTratativa.rotuloStatus(
        Number(idPropostaStatus),
        Number(this.idPerfilUsuarioLogado)
      );
      return rotulo ? `Tratativa - ${rotulo}` : "Tratativa";
    },
    qtdNaoLidasDaLinha(idApolice) {
      const resumo = this.resumoTratativas[idApolice];
      return resumo && resumo.qtdNaoLidas ? resumo.qtdNaoLidas : 0;
    },
    notificacaoInformativaDaLinha(idApolice) {
      const resumo = this.resumoTratativas[idApolice];
      return !!(resumo && resumo.notificacaoInformativa);
    },
    temTratativa(idApolice) {
      return !!this.resumoTratativas[idApolice];
    },
    abrirDialogTratativa(idApolice) {
      const apolice = this.apoliceList.find(a => a.id == idApolice);
      this.idApoliceTratativa = idApolice;
      this.dadosSolicitacaoTratativa = apolice
        ? {
            razaoSocial: apolice.proponenteRazaoSocial,
            cnpj: this.formatarCnpj(apolice.proponenteCnpj),
            numeroReserva: apolice.numeroReserva,
            idApolice: apolice.id,
            dataCriacao: this.formatarData(apolice.dateInicio)
          }
        : null;
      this.dialogTratativa = true;
    },
    fecharDialogTratativa() {
      this.dialogTratativa = false;
      this.idApoliceTratativa = null;
      this.dadosSolicitacaoTratativa = null;
      this.buscarResumoTratativas();
    },
    iniciarPollingTratativas() {
      this.pararPollingTratativas();
      this.buscarResumoTratativas();
      this.intervaloResumoTratativas = setInterval(() => {
        if (document.hidden === false) {
          this.buscarResumoTratativas();
        }
      }, INTERVALO_RESUMO_TRATATIVAS);
    },
    pararPollingTratativas() {
      if (this.intervaloResumoTratativas != null) {
        clearInterval(this.intervaloResumoTratativas);
        this.intervaloResumoTratativas = null;
      }
    },
    buscarResumoTratativas() {
      const idsApolice = this.apoliceList
        .filter(apolice => statusTratativa.exibeIconeChat(Number(apolice.idPropostaStatus)))
        .map(apolice => apolice.id);

      if (idsApolice.length === 0) {
        this.resumoTratativas = {};
        return;
      }

      axios
        .post(
          `${process.env.URL_TRATATIVAMS}/v1/resumo`,
          { idsApolice: idsApolice },
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          const resumos = response.data instanceof Array ? response.data : [];
          const mapa = {};
          resumos.forEach(resumo => {
            mapa[resumo.idApolice] = resumo;
          });
          this.resumoTratativas = mapa;
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscaEnderecosUf() {
      axios.get(`${process.env.URL_APOLICEMS}/v1/enderecoUf`, {
        headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
      .then(res => {
        return res.data;
      })
      .then(data => {
        this.listaUfEndereco = data;
      }).catch(err => {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Não foi possível resgatar a lista.";
      })
    },
    dadosFiltroLimpados(val) {
      this.filtroAtivado = false;
      this.$store.commit("startLoading");
      sessionStorage.removeItem("filtroObjetoString")
      this.paginacao.page = 1;
      this.buscarApolices();
      this.$store.commit("endLoading");
    },
    verificarFiltroAtivo() {
      if (this.modelFiltro.tipoFiltroAtivo === 'APOLICES') {
        this.buscarApolicesFiltradasRequest()
      } else if (this.modelFiltro.tipoFiltroAtivo === 'ENDOSSOS') {
        this.buscarApolicesEndossosFiltradasRequest()
      }
    },
    recarregarLista() {
      if (this._recarregamentoAgendado) return;
      this._recarregamentoAgendado = true;
      this.$nextTick(() => {
        this._recarregamentoAgendado = false;
        if (this.filtroAtivado) {
          this.verificarFiltroAtivo();
        } else if (this.filtro.pesquisa.conteudo) {
          this.buscarApoliceQuery();
        } else {
          this.buscarApolices();
        }
      });
    },
    tratamentoRequestFiltrarDados(val) {
      this.modelFiltro = {...val};
      this.filtroAtivado = true;
      if (this.modelFiltro.tipoFiltroAtivo === 'APOLICES') {
        this.modelFiltro = {
          ...this.modelFiltro,
          tipoFiltroAtivo: 'APOLICES'
        }
        this.buscarApolicesFiltradasRequest()
      } else if (this.modelFiltro.tipoFiltroAtivo === 'ENDOSSOS') {
        this.modelFiltro = {
          ...this.modelFiltro,
          tipoFiltroAtivo: 'ENDOSSOS'
        }
        this.buscarApolicesEndossosFiltradasRequest();
      }
    },
    buscarApolicesFiltradasRequest() {
      this.loaderFiltro = true;
      var requestBody = {
        listaIdStatus: this.modelFiltro.listaIdStatus,
        idInicioVigencia: this.modelFiltro.idInicioVigencia,
        listaIdCobertura: this.modelFiltro.listaIdCobertura,
        listaIdEnderecoUf: this.modelFiltro.listaIdEnderecoUf,
        listaIdCategoriaVeiculo: this.modelFiltro.listaIdCategoriaVeiculo,
        listaIdSeguro: this.modelFiltro.listaIdSeguro,
        listaIdTecnicoResponsavel: this.modelFiltro.listaIdTecnicoResponsavel,
      }
      axios.post(`${process.env.URL_APOLICEMS}/v1/filtrarCotacoes?page=${this.paginacao
        .page - 1}&size=${this.paginacao.rowsPerPage}${this.paramsOrdenacao()}`, requestBody, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(res => {

        this.apoliceList = res.data.content;
        this.paginacao.totalItems = res.data.totalElements;

        if (this.paginacao.page > Math.ceil(res.data.totalElements / this.paginacao.rowsPerPage)) {
          this.paginacao.page = 1;
        }

      }).finally(() => {
        this.loaderFiltro = false;

      })
    },
    buscarApolicesEndossosFiltradasRequest() {
      this.loaderFiltro = true;
      var requestBody = {
        listaIdStatusEndosso: this.modelFiltro.listaIdStatusEndosso,
        listaIdTecnicoResponsavelEndosso: this.modelFiltro.listaIdTecnicoResponsavelEndosso
      }
      axios.post(`${process.env.URL_APOLICEMS}/v1/filtrarApolicesEndossos?page=${this.paginacao
        .page - 1}&size=${this.paginacao.rowsPerPage}${this.paramsOrdenacao()}`, requestBody, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(res => {

        this.apoliceList = res.data.content;
        this.paginacao.totalItems = res.data.totalElements;

        if (this.paginacao.page > Math.ceil(res.data.totalElements / this.paginacao.rowsPerPage)) {
          this.paginacao.page = 1;
        }

      }).finally(() => {
        this.loaderFiltro = false;

      })
    },
    btnRenovacao() {
      this.$router.push(`/GridPrincipal/InfoGerais?id=${this.selected}&apoliceRenovacao=${true}`);
    },
    retornaQuantidadeTipoClassificacao(id) {
      axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarQuantidadeApolicePorTipoClassificacao/${id}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      ).then(response => {
        if(response.data) {
          if(id == 1) {
            this.nmrClassificacaoBaixa =  response.data;
          } else if(id == 2) {
            this.nmrClassificacaoMedia = response.data;
          } else if(id == 3) {
            this.nmrClassificacaoAlta = response.data;
          }
        }

      }).catch(error => {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Não foi possivel carregar os numeros de classificação de prioridade."
      })

    },
    filtrarPorTipoClassificacao(idTipoClassificao) {
      if(idTipoClassificao) {
        this.$store.commit("startLoading");
        axios
          .get(
            `${process.env.URL_APOLICEMS}/v1/listarClassificacao?idClassificacao=${idTipoClassificao}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          ).then(response => {
          this.apoliceList = response.data.content;
          this.paginacao.totalItems = response.data.totalElements;
          if(idTipoClassificao == 3) {
            this.nmrClassificacaoAlta = response.data.numberOfElements;
          }
          else if(idTipoClassificao == 2) {
            this.nmrClassificacaoMedia = response.data.numberOfElements;
          }
          else if(idTipoClassificao == 1) {
            this.nmrClassificacaoBaixa = response.data.numberOfElements;
          }
        }).catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Não foi possível regstar a lista.";
        })
        this.$store.commit("endLoading");

      }

    },
    tratamentoBotaoClassificacao(idClassificacao) {
      if(idClassificacao == 1) {
        this.btnClassificacaoBaixa = !this.btnClassificacaoBaixa;
        this.btnClassificacaoMedia = false;
        this.btnClassificacaoAlta = false;
        sessionStorage.setItem('idClassificacaoBotaoPrioridadeCotacao', this.btnClassificacaoBaixa ? idClassificacao : null)
      }
      if(idClassificacao == 2) {
        this.btnClassificacaoMedia = !this.btnClassificacaoMedia;
        this.btnClassificacaoBaixa = false;
        this.btnClassificacaoAlta = false;
        sessionStorage.setItem('idClassificacaoBotaoPrioridadeCotacao',this.btnClassificacaoMedia ? idClassificacao : null)
      }
      if(idClassificacao == 3) {
        this.btnClassificacaoAlta = !this.btnClassificacaoAlta;
        this.btnClassificacaoBaixa = false;
        this.btnClassificacaoMedia = false;
        sessionStorage.setItem('idClassificacaoBotaoPrioridadeCotacao', this.btnClassificacaoAlta ? idClassificacao : null)
      }
      if(this.btnClassificacaoAlta || this.btnClassificacaoBaixa || this.btnClassificacaoMedia) {
        this.filtrarPorTipoClassificacao(idClassificacao);
      } else if(!this.btnClassificacaoAlta && !this.btnClassificacaoMedia && !this.btnClassificacaoBaixa) {
        this.buscarApolices();
      }

    },

    async abrirdialog() {
      this.$store.commit("startLoading");
      try {
        const response = await axios.get(
          `${process.env.URL_ENDOSSOMS}/v1/retornaTipoEndossos/${this.selected}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        );
        const tipos = Array.isArray(response.data) ? response.data : [];
        if (tipos.length === 0) {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem =
            "Nenhum tipo de endosso disponível para esta apólice.";
          return;
        }
        this.tipoEndossoList = tipos;
        this.$store.commit("formEndosso/limparTudo");
        this.dialog = true;
      } catch (error) {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem =
          "Não foi possível carregar os tipos de endosso.";
      } finally {
        this.$store.commit("endLoading");
      }
    },
    abrirdialogHistorico(id, numeroProposta, statusProposta) {
      if (numeroProposta) {
        this.numeroPropostaHistorico = numeroProposta.toString();
      } else {
        this.numeroPropostaHistorico = "0";
      }
      if (id) {
        this.idApoliceClick = id;
      } else {
        this.idApoliceClick = 0;
      }
      this.statusPropostaHistorico = statusProposta;
      this.dialogHistorico = true;
    },
    camposDisabled() {
      return this.idPropostaStatus > 1;
    },
    mostrarError(model) {},
    fecharDialogoEndosso() {
      this.dialogEndosso = false;
      this.idTipoEndosso = null;
    },

    fecharDialogEndossoCancelamento() {
      this.dialogEndossoCancelamento = false;
      this.idTipoEndosso = null;
    },

    fecharDialogHistorico() {
      this.dialogHistorico = false;
    },

    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric"
        });
      }
    },
    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },
    processarArquivo(event) {
      this.arquivo = event.target.files[0] || {};
    },

    paramsOrdenacao() {
      const sortBy = this.paginacao.sortBy || "";
      const sortDir = this.paginacao.descending ? "desc" : "asc";
      return `&sortBy=${sortBy}&sortDir=${sortDir}`;
    },
    buscarApolices() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/listarApolices?page=${this.paginacao
            .page - 1}&size=${this.paginacao.rowsPerPage}${this.paramsOrdenacao()}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.apoliceList = response.data.content;
          this.paginacao.totalItems = response.data.totalElements;
          if (this.paginacao.page > Math.ceil(response.data.totalElements / this.paginacao.rowsPerPage)) {
            this.paginacao.page = 1;
          }
          this.filtroFunctions().aplicarFiltros();
          this.$store.commit("endLoading");
        })
        .catch(err => {
        });
        this.$store.commit("endLoading");
    },
    buscarStatus() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/propostaStatus`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.propostaStatusList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarVersionamentoEssor() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/versionamentoessor`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response.data instanceof Array) {
            let index = 0;
            for (var dado of response.data.reverse()) {
              this.listaVersionamentoEssor.push({
                titulo: "Versão: ",
                inicioVigencia: dado.inicioVigencia,
                fimVigencia: dado.fimVigencia ? dado.fimVigencia : "Vigente",
                versao: dado.numeroVersao
              })
              if (index === 0) {
                this.versionamentoEssorDefault = {
                  titulo: "N° Versão: ",
                  versao: dado.numeroVersao
                }
              }
              index++
            }
          } else {
            []
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarInicioVigencia() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/retornaListaFiltroVigencia`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.inicioVigenciaList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarCoberturasFiltro() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/retornaListaFiltroCobertura`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.listaCoberturasFiltro =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarSegurosFiltro() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/apoliceTipoDeProposta`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.listaSegurosFiltro =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarCategoriasVeiculo() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/retornaListaCategoriaVeiculo`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.listaCategoriaVeiculo =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.log(err);
        })
    },
    buscarApoliceQuery() {
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/listarApolices?searchQuery=${this.filtro.pesquisa.conteudo}${this.paramsOrdenacao()}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.apoliceList = response.data.content;
          this.paginacao.totalItems = response.data.totalElements;
        })
        .catch(err => {
          console.error(err);
        });
    },
    traduzirStatus(idPropostaStatus) {
      const status = this.propostaStatusList.find(
        item => item.id === idPropostaStatus
      );
      return status ? status.titulo : "";
    },
    buscarTecnicosResponsaveis() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarTecnicosResponsaveisApolice`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.propostaTecnicoResponsavelList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },
    buscarStatusEndossos() {
      axios
        .get(`${process.env.URL_ENDOSSOMS}/v1/buscarListaStatusEndosso`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.endossoStatusList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    },

    toLocaleString: function(datetime) {
      return CustomFormat.toLocaleDateTimeString(datetime);
    },

    filtroFunctions: function() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },

    salvarPlanilhaModelo() {

      this.$store.commit("startLoading");
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/downloadPlanilhaModelo`, {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          const arquivo = response.data;
          const blob = new Blob([arquivo], {
            type: response.headers["content-type"]
          });
          saveAs(blob, "PlanilhaModelo.xlsx");
        })
        .catch(err => {})
        .finally(() => {
          this.$store.commit("endLoading");
        });
    },
    submeterArquivo(enviarComErros) {
      this.loading = true;
      const formData = new FormData();
      formData.append("planilha", this.arquivo);
      formData.append("ignorarErros", enviarComErros);
      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/validarPlanilha`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response.data) {
            if(response.data.erroMensagemReservaMercado	) {
              this.arquivoValido = false;
              this.erro = response.data.erroMensagemReservaMercado;
              this.mostrarBotaoImportarComErros = true;
            } else {
              this.arquivoValido =
              typeof response.data.valido === "boolean"
                ? response.data.valido
                    : true;
                this.arquivoFaltante =
                  response.data.naoEncontrados instanceof Array
                    ? response.data.naoEncontrados
                  : [];
                this.conteudoPlanilha =
                  response.data.conteudo instanceof Array
                    ? response.data.conteudo
                    : [];
                this.erroPlanilha =
                  response.data.erros instanceof Array ? response.data.erros : [];
              }
              if (this.arquivoValido) {
                this.avaliarPlanilha();
              }
            }
        })
        .catch(error => {
          this.arquivoValido = false;
          this.erro = error.response.data.message;
          this.mostrarModalImportarComErros(this.erro)
        })
        .finally(() => {
          this.loading = false;
        });
    },

    mostrarModalImportarComErros(mensagemErro) {
      if (mensagemErro.toLowerCase().includes(this.mensagemChassiConstaApoliceVigente.toLowerCase())
        || mensagemErro.toLowerCase().includes(this.mensagemChassiPossuiReservaMercado.toLowerCase())) {
        this.mostrarBotaoImportarComErros = true;
      }
    },

    fecharDialogArquivo() {
      this.dialogFile = false;
      this.arquivoValido = true;
      this.arquivoFaltante = [];
      this.arquivo = {};
      this.mostrarBotaoImportarComErros = false;
    },

    avaliarPlanilha() {
      if (!(this.conteudoPlanilha instanceof Array)) {
        return;
      }
      this.fecharDialogArquivo();
      this.dialogProgress = true;
      setTimeout(() => {
        this.$store.commit("formCotacao/setConteudoPlanilha", {
          dados: planilhaItens.mesclarErrosNosItens(
            this.conteudoPlanilha,
            this.erroPlanilha
          ),
        });

        this.$store.commit("formCotacao/setErroPlanilha", {
          dados: this.erroPlanilha
        });
        this.$store.commit("formCotacao/setCopiaParcial", false);
        this.dialogProgress = false;
        this.mostrarBotaoImportarComErros = false;
        this.snackbar.visivel = true;
        this.snackbar.sucesso = true;
        this.snackbar.mensagem = "Arquivo importado com sucesso";
        this.$router.push({ path: "/GridPrincipal/InfoGerais" });
      }, 5000);
    },


    abrirApolice(idApolice) {
      this.$router.push(`/GridPrincipal/InfoGerais?id=${idApolice}`);
    },

    abrirDialogCopiarCotacao() {
      this.dialogCopiarCotacao = true;
    },

    confirmarCopiaCotacao({ copiaParcial }) {
      this.dialogCopiarCotacao = false;
      this.$store.commit("formCotacao/setCopiaParcial", copiaParcial);
      this.copiarProposta(this.selected);
    },

    copiarProposta(idApolice) {
      this.$router.push(`/GridPrincipal/InfoGerais?id=${idApolice}&apoliceCopiada=${true}`);
    },

    proximaPagina: function() {
      if (this.idTipoEndosso != null) {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.selected}&idTipoEndosso=${this.idTipoEndosso}`
        );
      }
    },


    buscarApolicesByStatus(status) {
      if(status === 0) {
        this.buscarApolices();
      } else {
        this.$store.commit("startLoading");
        axios
          .get(
            `${process.env.URL_APOLICEMS}/v1/listarApolices?page=${this.paginacao
              .page - 1}&size=${this.paginacao.rowsPerPage}&idPropostaStatus=${status}${this.paramsOrdenacao()}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
          .then(response => {
            this.apoliceList = response.data.content;
            this.paginacao.totalItems = response.data.totalElements;
            if (this.paginacao.page > Math.ceil(response.data.totalElements / this.paginacao.rowsPerPage)) {
              this.paginacao.page = 1;
            }
            this.$store.commit("endLoading");
          })
          .catch(err => {
            this.$store.commit("endLoading");
          });
      }
    },
    formatNomeTecnicoResponsavel(nome) {
      if(nome == null) {
        return ""
      } else if(nome.length > 7)  {
        return nome.substring(0, 8).concat("...")
      } else {
        return nome
      }
    }
  }
};
</script>

<style>
  .coluna-status-tratativa {
    white-space: nowrap;
    text-align: left;
  }

  .coluna-status-tratativa__conteudo {
    display: inline-flex;
    align-items: center;
  }

  .datatable-footer-custom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    padding: 6px 16px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }

  .datatable-footer-custom__perpage {
    display: flex;
    align-items: center;
    margin-right: 32px;
  }

  .datatable-footer-custom__label {
    margin-right: 12px;
  }

  .datatable-footer-custom__select {
    width: 56px;
    margin: 0;
    padding: 0;
  }

  .datatable-footer-custom__range {
    margin-right: 24px;
  }

  .table-grid thead {
    background-color: #00456e;
  }

  .table-grid .column {
    color: #fff !important;
  }

  .error--text {
    color: red!important;
  }

  .table-grid th i {
    color: #fff !important;
  }

  .dialog {
    background: #eaeaea !important;
  }

  .headline {
    color: #fff;
    font-size: 14px !important;
  }

  .text-error {
    color: #f45353;
    font-weight: bold;
  }

  .name-arquivo {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px 10px;
    background-color: #fff;
    border-radius: 2px;
  }

  input[type="file"] {
    display: none;
  }

  .button-custom {
    width: 100%;
    max-width: 121px;
    text-align: center;
    color: #fff !important;
    background-color: #00456e;
    border-radius: 2px;
    display: inline-block;
    padding: 9px 12px;
    cursor: pointer;
    font-weight: bold;
  }

  .button-custom.error {
    max-width: 180px;
    color: white;
  }

  .button-custom:hover {
    background-color: #063f57;
  }

  .disabled,
  .v-btn.button-custom:disabled {
    cursor: default;
    background-color: #063f57;
    color: #aaaaaa !important;
  }

  .disabled:hover {
    background-color: #063f57;
  }

  .click {
    cursor: pointer;
  }

  .size {
    size: 1;
  }

  .btn-dialog-historico {
    border: 0;
    background-color: transparent;
    text-transform: uppercase;
    text-align: center;
    color: #027db4;
    box-shadow: none;
  }

  .btn-dialog-historico:hover {
    text-decoration: underline;
  }

  .table-grid thead th {
      white-space: normal!important;
      padding-right: 22px;
  }

  .table-grid thead th:last-child {
    padding-right: 8px;
  }

  .table-grid thead td:not(:nth-child(1)),
  .table-grid tbody td:not(:nth-child(1)),
  .table-grid thead th:not(:nth-child(1)),
  .table-grid tbody th:not(:nth-child(1)),
  .table-grid thead td:first-child,
  .table-grid tbody td:first-child,
  .table-grid thead th:first-child,
  .table-grid tbody th:first-child {
    padding: 0 22px 0 0!important;
  }

  .table-grid thead td:last-child
  {
    padding: 0 8px 0 0!important;
  }

  .table-grid .column .v-icon {
    position: absolute!important;
    right: 3px;
    width: 20px;
    height: 20px;
    top: 19px;
  }

  .table-grid thead th.column.sortable {
    position: relative;
  }

  .wrapper-classificao-cotacao {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn-prioridade {
    border: 1px solid #00456e !important;
    border-radius: 50px !important;
    font-weight: bold !important;
    padding: 22px 26px 22px 4px !important;
    text-transform: uppercase !important;
    transition: 0.2s all !important;
    display: flex !important;
    align-items: center !important;
  }

  .btn-prioridade span {
    color: #00456e ;
    display: block;
  }

  .btn-prioridade.ativo span {
    color: white;
  }

  .btn-prioridade.ativo {
    background-color: #00456e;
  }

  .divisao-contador p {
    margin-bottom: 0;
    color: white;
  }

  .divisao-contador {
    margin-right: 8px;
    width: 38px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }

  .divisao-contador.baixa {
    background-color: #8C9EFF;
  }

  .divisao-contador.media {
    background-color: #FF9800;
  }

  .divisao-contador.alta {
    background-color: #E53935;
  }

  .title-prioridade {
    margin-bottom: 0;
    color: #00456e;
    font-weight: bold;
    margin-right: 6px;
  }

  .loader-overlay {
    display: flex!important;
    justify-content: center;
    align-items: center;
    background-color: transparent!important;
    height: 100%;
    overflow: hidden!important;
    box-shadow: none!important;
  }

  .no-data-apolice {
    font-size: 14px;
    font-weight:bold;
    margin-bottom:0;
    text-align: center
  }

  .grid-principal__barra {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
  }

  .grid-principal__busca,
  .grid-principal__acoes {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .grid-principal__busca {
    flex: 1 1 420px;
  }

  .grid-principal__acoes {
    justify-content: flex-end;
  }

  .grid-principal__campo-busca {
    max-width: 340px;
    margin-left: 16px;
  }

  .grid-principal__tabela {
    padding: 0 10px;
  }

  .versionamento {
    flex: 0 0 180px;
    margin-right: 12px;
    padding-top: 0;
    opacity: 0.6;
  }

  @media (max-width: 960px) {
    .grid-principal__busca,
    .grid-principal__acoes {
      flex-basis: 100%;
    }

    .grid-principal__campo-busca {
      max-width: none;
    }
  }

  .text-align-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/GridPrincipal.vue